module.exports = __webpack_public_path__ + "static/media/discover.a8f2bf3d.svg";